import { FC } from 'react';
import { BoxSetContentsModalViewType } from '../../types/view/BoxSetContentsModalViewType';
import { CommonModal } from '../CommonModal';
import styles from '../../assets/scss/BoxProductModal/BoxSetContentsModal.module.scss';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';

type Props = {
  active: boolean;
  closeFunc: () => void;
  modal: BoxSetContentsModalViewType | null;
};

export const BoxSetContentsModal: FC<Props> = ({ active, closeFunc, modal }) => {
  if (!modal) {
    return null;
  }

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      <div className={styles.container}>
        <h2 className={styles.heading}>セット内容</h2>

        <ul className={styles.list}>
          {modal.lines.map((line, index) => (
            <li
              key={`${line.displayName}-${index}`}
              className={styles.line}
            >
              {line.displayName} ×{line.quantity}
            </li>
          ))}
        </ul>

        <p className={styles.totalRow}>
          <span className={styles.totalLabel}>合計 </span>
          <span className={styles.totalValue}>{modal.totalQuantity}</span>
          <span className={styles.totalUnit}> {modal.displayUnit}</span>
        </p>

        <div className={commonModalClass.btnContainer}>
          <button
            type="button"
            onClick={closeFunc}
          >
            閉じる
          </button>
        </div>
      </div>
    </CommonModal>
  );
};